import { AppBar, Dialog, IconButton, Toolbar } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useStyles } from '@webapps/styles';
import PropTypes from 'prop-types';

const ModalFullScreenWithoutAction = ({ children, onCancel, open, title }) => {
  const { css } = useStyles();

  return (
    <Dialog fullScreen onClose={onCancel} open={open}>
      <AppBar className={css({ position: 'relative' })}>
        <Toolbar>
          <IconButton
            aria-label="close"
            color="inherit"
            edge="start"
            onClick={onCancel}
          >
            <CloseIcon />
          </IconButton>
          {title}
        </Toolbar>
      </AppBar>
      {children}
    </Dialog>
  );
};

ModalFullScreenWithoutAction.propTypes = {
  open: PropTypes.bool,
  children: PropTypes.node,
  title: PropTypes.node,
  onCancel: PropTypes.func,
};

export default ModalFullScreenWithoutAction;
